import { Button, Chip, InputAdornment, MenuItem, TextField } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getClientById, setClientById } from '../../../redux/slices/clients';
import PreFacturaAccordionEquipamnt from '../../../components/accordion/PreFacturaAccordions/PreFacturaAccordionEquipamnt';
import PreFacturaAccordionItems from '../../../components/accordion/PreFacturaAccordions/PreFacturaAccordionItems';
import PreFacturaAccordionRepuestos from '../../../components/accordion/PreFacturaAccordions/PreFacturaAccordionRepuestos';
import { useState } from 'react';
import { createFacturacion } from '../../../redux/slices/facturacion';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import uploadFiles from '../../../utils/UploadFiles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/es';
import dayjs from 'dayjs';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { getAllServices, setServices } from '../../../redux/slices/services';
import PreFacturaAccordionServices from '../../../components/accordion/PreFacturaAccordions/PreFacturaAccordionServices';
import { getAllGanancias } from '../../../redux/slices/ganancias';
import { getAllRiesgo } from '../../../redux/slices/riesgo';
import thousandSeparator from '../../../utils/thousandSeparator';
import removeNonNumeric from '../../../utils/removeNaN';
import * as React from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Modal from '@mui/material/Modal';

export default function PreFacturaId() {
  const [equiposAsignados, setEquiposAsignados] = useState([]);
  const [riesgoCliente, setRiesgoCliente] = useState('');
  const [subTotalEquipos, setSubTotalEquipos] = useState(0);
  const [descuento, setDescuento] = useState(0);
  const [totalDescuento, setTotalDescuento] = useState(0);
  const [itemsAsignados, setItemsAsignados] = useState([]);
  const [subTotalItems, setSubTotalItems] = useState(0);
  const [nroOcMp, setNroOcMp] = useState('');
  const [nroOc, setNroOc] = useState('');
  const [monto, setMonto] = useState('');
  const [montoIva, setMontoIva] = useState('');
  const [montoSinIva, setMontoSinIva] = useState('');
  const [montoSinIvaNumber, setMontoSinIvaNumber] = useState('');
  const [date, setDate] = useState(dayjs());
  const [dateFacturacion, setDateFacturacion] = useState(dayjs());
  const [repuestosAsignados, setRepuestosAsignados] = useState([]);
  const [ganEquipos, setGanEquipos] = useState(0);
  const [ganRepuestos, setGanRepuestos] = useState(0);
  const [ganArticulos, setGanArticulos] = useState(0);
  const [subTotalRepuestos, setSubTotalRepuestos] = useState(0);
  const [totalesRepuestos, setTotalesRepuestos] = useState(0);
  const [totalesInsumos, setTotalesInsumos] = useState(0);
  const [totalesEquipos, setTotalesEquipos] = useState(0);
  const [serviciosAsignados, setServiciosAsignados] = useState([]);
  const [subTotalServicios, setSubTotalServicios] = useState(0);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);

  const [observacion, setObservacion] = useState('');
  const [file, setFile] = useState({});
  const [isParcial, setIsParcial] = useState(false);
  const [isMultiple, setIsMultiple] = useState(true);
  const [generateOt, setGenerateOt] = useState(false);
  const [serviceId, setServicesId] = useState(0);
  const [nroLicitacion, setNroLicitacion] = useState('');
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { client } = useSelector((state) => state.clients);
  const { currentUser } = useSelector((state) => state.auth);
  const { services } = useSelector((state) => state.services);
  const { ganancias } = useSelector((state) => state.ganancias);
  const { riesgo } = useSelector((state) => state.riesgo);

  useEffect(() => {
    dispatch(getClientById(id));
    dispatch(getAllServices());
    dispatch(getAllGanancias());
    dispatch(getAllRiesgo());

    return () => {
      dispatch(setClientById({}));
      dispatch(setServices([]));
    };
  }, []);

  function formatNumber(value) {
    return value.toLocaleString('es-ES');
  }

  useEffect(() => {
    const array = [];
    if (Object.keys(client).length && riesgo.length) {
      client?.facturacion_facturacion_clienteTocliente?.forEach((el) => {
        if (el.cobranza.length) {
          el.cobranza.forEach((cob) => {
            if (cob.cobranza_pagos.length) {
              array.push({ f_vencimiento: cob.f_vencimiento, f_pago: cob.cobranza_pagos[0].f_pago });
            }
          });
        }
      });
      let suma = 0;
      let cant = 0;
      array.forEach((el) => {
        const diffInDays = dayjs(el.f_vencimiento).diff(dayjs(el.f_pago), 'day');
        suma += diffInDays;
        cant += 1;
      });
      let diff = suma / cant;
      let riesgoFilter = riesgo.filter((el) => {
        return parseInt(el.desde) <= diff && parseInt(el.hasta) >= diff;
      });
      if (cant > 0) {
        setRiesgoCliente(riesgoFilter[0]?.name);
      } else {
        setRiesgoCliente('SIN HISTORIAL');
      }
    }
  }, [client, riesgo]);

  useEffect(() => {
    if (ganancias) {
      let equipoGanancia = ganancias.find((el) => el.id === 3);
      let repuestosGanancia = ganancias.find((el) => el.id === 2);
      let articulosGanancia = ganancias.find((el) => el.id === 1);
      setGanEquipos(equipoGanancia?.porcentaje);
      setGanRepuestos(repuestosGanancia?.porcentaje);
      setGanArticulos(articulosGanancia?.porcentaje);
    }
  }, [ganancias]);

  useEffect(() => {
    if (generateOt === true) {
      setOpen(true);
    }
  }, [generateOt]);

  useEffect(() => {
    let monto =
      // subTotalItems +

      // (ganArticulos * subTotalItems) / 100 +
      // (subTotalEquipos + (ganEquipos * subTotalEquipos) / 100) +
      subTotalEquipos + subTotalItems + subTotalRepuestos + subTotalServicios;
    // (subTotalRepuestos + (ganRepuestos * subTotalRepuestos) / 100);
    if (monto >= 1000) {
      setMontoSinIva(thousandSeparator(monto));
      setMontoSinIvaNumber(monto);
    } else {
      setMontoSinIvaNumber(monto);
      setMontoSinIva(monto);
    }
    if (monto - (descuento / 100) * monto >= 100) {
      let amount = monto;

      if (typeof monto === 'string' && monto.includes('.')) {
        amount = monto.replaceAll('.', '');
      }
      setTotalDescuento(thousandSeparator(Math.round(amount - (descuento / 100) * amount)));
    } else {
      let amount = monto;
      if (typeof monto === 'string' && monto.includes('.')) {
        amount = monto.replaceAll('.', '');
      }

      setTotalDescuento(amount - (descuento / 100) * amount);
    }
  }, [subTotalEquipos, subTotalItems, subTotalRepuestos, subTotalServicios]);

  const handleChangeFile = (e) => {
    setFile(e.target.files[0]);
  };

  const handleOc = (e) => {
    setNroOcMp(e.target.value);
  };

  const handleOcNoMP = (e) => {
    setNroOc(e.target.value);
  };

  const handleMonto = (e) => {
    // let val = e.target.value;
    // setMonto(thousandSeparator(removeNonNumeric(e.target.value)));
    // if (typeof val === "string" && val.includes(".")) {
    //   val = e.target.value.replaceAll(".", "");
    // }
    // setTotalDescuento(thousandSeparator(Math.round(val - (descuento / 100) * val)));
  };

  const handleDescuento = (e) => {
    setDescuento(e.target.value);
    let amount = monto;
    if (typeof monto === 'string' && monto.includes('.')) {
      amount = monto.replaceAll('.', '');
    }
    setTotalDescuento(thousandSeparator(Math.round(amount - (e.target.value / 100) * amount)));
  };

  const handleDateChange = (e) => {
    setDate(e);
  };

  const handleDateFacturacionChange = (e) => {
    setDateFacturacion(e);
  };

  const handleObservation = (e) => {
    setObservacion(e.target.value);
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const values = {};
    if (file.name) {
      const uploaded = await uploadFiles('docs', file);
      values.file_oc = uploaded.data;
    }
    const equipos = [];
    const repuestos = [];
    if (equiposAsignados.length) {
      equiposAsignados.forEach((equipo) => equipos.push(equipo));
    }
    if (repuestosAsignados.length) {
      repuestosAsignados.forEach((repuesto) => repuestos.push(repuesto));
    }
    values.cliente = id;
    values.responsable = currentUser.id;
    values.equipos = equipos;
    values.articulos = itemsAsignados;
    values.repuestos = repuestos;
    values.nro_oc = nroOcMp;
    values.fecha_oc = date;
    values.pago_parcial = isParcial;
    values.observacion = observacion;
    values.multiple = isMultiple;
    values.generateOt = generateOt;
    values.monto = typeof monto === 'string' && monto.includes('.') ? parseInt(monto.replaceAll('.', '')) : monto;
    values.montoSinDesc = typeof monto === 'string' && monto.includes('.') ? parseInt(monto.replaceAll('.', '')) : monto;
    values.servicios = serviciosAsignados;
    values.clienteNombre = client.nombre;
    values.descuento = descuento;
    values.nro_oc_noMP = nroOc;
    values.nroLicitacion = nroLicitacion === '' ? null : nroLicitacion;

    const res = await dispatch(createFacturacion(values));
    if (res.status === 201) {
      navigate('/orden-de-compra');
    }
  };

  const handleServiceChange = (e) => {
    setServicesId(e.target.value);
  };

  useEffect(() => {
    let iva = Math.round((montoSinIvaNumber * 19) / 100);
    let monto = Math.round(montoSinIvaNumber + iva);
    setMontoIva(thousandSeparator(iva));
    setMonto(thousandSeparator(monto));
  }, [montoSinIvaNumber]);

  return (
    <div>
      {client && Object.keys(client).length > 0 ? (
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className="flex mb-2">
            <div className="w-[10%] flex items-center">
              <Chip label="Volver" sx={{ minWidth: '100px' }} color="primary" onClick={() => navigate('/orden-de-compra')} />
            </div>
          </div>
          <div className="flex justify-between mb-10">
            <div>
              <div className="flex">
                <div className="min-w-[150px] font-semibold">NOMBRE: </div>
                <div>{client.nombre?.toUpperCase()}</div>
              </div>
              <div className="flex">
                <div className="min-w-[150px] font-semibold ">DIRECCION: </div>
                <div>{client.direccion?.toUpperCase()}</div>
              </div>
              <div className="flex">
                <div className="min-w-[150px] font-semibold ">RUT: </div>
                <div>{client.rut} </div>
              </div>
              <div className="flex">
                <div className="min-w-[150px] font-semibold ">MAIL CONTACTO: </div>
                <div>{client.mail_contacto?.toUpperCase()} </div>
              </div>
            </div>
            <div>
              <div className="text-4xl flex pr-10">ORDEN DE COMPRA</div>
              <div className="flex justify-center mt-5">
                {riesgoCliente === 'ALTO' ? (
                  <Chip color="error" label="RIESGO ALTO" />
                ) : riesgoCliente === 'MEDIO' ? (
                  <Chip color="warning" label="RIESGO MEDIO" />
                ) : riesgoCliente === 'BAJO' ? (
                  <Chip color="success" label="RIESGO BAJO" />
                ) : riesgoCliente === 'SIN HISTORIAL' ? (
                  <Chip label="SIN HISTORIAL" />
                ) : (
                  <div></div>
                )}
              </div>
            </div>
          </div>
          <div className="mb-[50px]">
            <PreFacturaAccordionEquipamnt
              equiposAsignados={equiposAsignados}
              setEquiposAsignados={setEquiposAsignados}
              setSubTotalEquipos={setSubTotalEquipos}
              totalesEquipos={totalesEquipos}
              setTotalesEquipos={setTotalesEquipos}
              subTotalEquipos={subTotalEquipos}
              ganEquipos={ganEquipos}
            />
          </div>
          <div className="mb-[50px]">
            <PreFacturaAccordionRepuestos
              repuestosAsignados={repuestosAsignados}
              setRepuestosAsignados={setRepuestosAsignados}
              subTotalRepuestos={subTotalRepuestos}
              totalesRepuestos={totalesRepuestos}
              setTotalesRepuestos={setTotalesRepuestos}
              setSubTotalRepuestos={setSubTotalRepuestos}
              ganRepuestos={ganRepuestos}
            />
          </div>
          <div className="mb-[50px]">
            <PreFacturaAccordionItems
              totalesInsumos={totalesInsumos}
              setTotalesInsumos={setTotalesInsumos}
              itemsAsignados={itemsAsignados}
              setItemsAsignados={setItemsAsignados}
              subTotalItems={subTotalItems}
              setSubTotalItems={setSubTotalItems}
              ganArticulos={ganArticulos}
            />
          </div>
          <div className="mb-[50px]">
            <PreFacturaAccordionServices
              asignados={serviciosAsignados}
              setter={setServiciosAsignados}
              subTotalServicios={subTotalServicios}
              setSubTotalServicios={setSubTotalServicios}
            />
          </div>
          <div className="grid grid-cols-2 gap-10">
            <div>
              <div className="mb-5 flex gap-3">
                <TextField
                  disabled
                  value={montoSinIva}
                  fullWidth
                  id="monto"
                  label="Monto Neto"
                  size="small"
                  onChange={handleMonto}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">{'$'}</InputAdornment>,
                  }}
                />
                <TextField
                  value={montoIva}
                  fullWidth
                  id="iva"
                  disabled
                  label="IVA"
                  size="small"
                  onChange={handleMonto}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">{'$'}</InputAdornment>,
                  }}
                />
                <TextField
                  value={monto}
                  fullWidth
                  id="monto_total"
                  label="Monto Total"
                  size="small"
                  disabled
                  onChange={handleMonto}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">{'$'}</InputAdornment>,
                  }}
                />
                {/* <TextField
                  value={descuento}
                  fullWidth
                  id="descuento"
                  label="Porcentaje descuento"
                  size="small"
                  onChange={handleDescuento}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">{"%"}</InputAdornment>,
                  }}
                />
                <TextField
                  value={totalDescuento}
                  fullWidth
                  id="total_descuento"
                  label="Total con Descuento"
                  size="small"
                  onChange={handleMonto}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">{"$"}</InputAdornment>,
                  }}
                /> */}
              </div>
              <div className="mb-5 grid grid-cols-2 gap-5">
                <div className="">
                  <TextField fullWidth id="nro_oc_mp" label="Número de OC Mercado Público" size="small" onChange={handleOc} disabled={nroOc} />
                </div>
                {!!nroOcMp ? (
                  <TextField fullWidth id="nro_licitacion" label="Número de licitación" size="small" onChange={(e) => setNroLicitacion(e.target.value)} />
                ) : (
                  <TextField fullWidth id="nro_oc" label="Número de OC privada" size="small" onChange={handleOcNoMP} disabled={nroOcMp} />
                )}
              </div>
              <div className="flex gap-3">
                <div className="w-full">
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                    <DatePicker
                      label="Fecha OC"
                      sx={{ width: '100%' }}
                      value={date}
                      onChange={handleDateChange}
                      format={'DD/MM/YYYY'}
                      slotProps={{ textField: { size: 'small' } }}
                    />
                  </LocalizationProvider>
                </div>
                <div className="flex w-full">
                  <label className="mr-2"> Archivo: </label>
                  <Button variant="contained" component="label" size="small">
                    Subir
                    <input
                      hidden
                      accept=".pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,image/jpeg"
                      type="file"
                      onChange={handleChangeFile}
                    />
                  </Button>
                </div>
                <div className="flex ml-2 items-end w-[85%]">
                  {file.name && (
                    <div>
                      {file.name} <CheckCircleOutlineIcon sx={{ color: 'green', marginLeft: 2 }} />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div>
              <div className="mb-5">
                <TextField id="outlined-multiline-static" label="Observación" fullWidth multiline rows={3} onChange={handleObservation} />
              </div>
              <div className="grid grid-cols-3">
                <div>
                  <FormControlLabel control={<Switch onChange={(e) => setIsParcial(!isParcial)} />} label="Pago Parcial" />
                </div>
                <div>
                  <FormControlLabel control={<Switch onChange={(e) => setIsMultiple(!isMultiple)} checked={isMultiple} />} label="Multiple Facturacion" />
                </div>
                <div>
                  <FormControlLabel value={generateOt} control={<Switch onChange={(e) => setGenerateOt(!generateOt)} />} label="No Genera Ot" />
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center mt-5">
            <Button
              type="submit"
              variant="outlined"
              disabled={
                !(equiposAsignados.length || itemsAsignados.length || repuestosAsignados.length || Object.entries(serviciosAsignados).length) ||
                !(equiposAsignados.length || itemsAsignados.length || repuestosAsignados.length || serviciosAsignados.length) ||
                monto === '' ||
                (nroOcMp && nroLicitacion === '') ||
                loading
              }
            >
              Enviar
            </Button>
          </div>
        </form>
      ) : (
        <div className="w-[100%] h-screen flex justify-center items-center">
          <CircularProgress />
        </div>
      )}
      {/* <BasicModal open={open} setOpen={setOpen} /> */}
    </div>
  );
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
};

const BasicModal = ({ open, setOpen }) => {
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen}>Open modal</Button>
      <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={style}>
          <Alert variant="filled" severity="warning">
            <p>Al seleccionar esta opción, los equipos, repuestos e insumos seleccionados no se descontarán del stock</p>
          </Alert>
          <Button onClick={handleClose} variant="outlined" fullWidth sx={{ marginTop: 2 }}>
            Aceptar
          </Button>
        </Box>
      </Modal>
    </div>
  );
};
